import styled from 'styled-components';

const Container = styled.div`
  color: ${({ isWaiting }) => (isWaiting ? 'wait' : 'red')};
  min-height: 20px;
`;

export default Container;
